export const PLATFORMS = [
  {
    value: 0,
    label: "Other",
  },
  {
    value: 4,
    label: "Android",
  },
  {
    value: 1,
    label: "Windows",
  },
  {
    value: 2,
    label: "Mac OS",
  },
  {
    value: 3,
    label: "iOS",
  },
  {
    value: 5,
    label: "Other Mobile",
  },
];

export function getRatesPlatforms() {
  const platformForRates = PLATFORMS.filter((platform) => {
    return ["Android", "Windows", "Mac OS"].some(
      (item) => item === platform.label
    );
  });

  platformForRates.unshift({ value: "all", label: "All" });

  return platformForRates;
}
